import { useState, useRef, React } from 'react';
import styled from 'styled-components';

import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';

import TimeIcon from '../../image/TimeIcon.png';

export default function CourseHistoryTimeInput(props) {
	const { width, className, type, value, setValue } = props;
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

	// const [value, setValue] = useState('');
	const [changed, setChanged] = useState(false);
	const [changedPlaceholderColor, setChangedPlaceholderColor] = useState(false);
	const [clickCount, setClickCount] = useState(0);

	const inputRef = useRef();

	function onClickInput(e) {
		inputRef.current.style.borderColor = theme.primary;
	}

	function onChangeInput(e) {
    const regex = /^[0-9:\-\b]{0,11}$/;

		if (regex.test(e.target.value)) {
			if (e.target.value.length === 2)
				setValue(e.target.value.replace(/(\d{2})/, '$1:'));
			else if (e.target.value.length === 5)
				setValue(e.target.value.replace(/(\d{2}):(\d{2})/, '$1:$2-'));
			else if (e.target.value.length === 8)
				setValue(e.target.value.replace(/(\d{2}):(\d{2})-(\d{2})/, '$1:$2-$3:'));
			else
				setValue(e.target.value);
		}
	
		setChanged(true);
	}

	function onKeyDownInput(e) {
		if (e.key === 'Backspace') {
			if (value.length === 3 || value.length === 6 || value.length === 9) {
				setValue(value.substring(0, value.length - 1));
			}
		}
	}

	function onFocusInput(e) {
		setChangedPlaceholderColor(false);
		if (changed) {
			// do nothing
		}
else {
			setValue("");
		}
	}

	function onBlurInput(e) {
		setClickCount(clickCount + 1);
		inputRef.current.style.borderColor = theme.line;
	}

	return (
    <InputWrapper width={width}>
      <TimeImage src={TimeIcon} />
      <Input
        ref={inputRef}
        clickCount={clickCount}
        type={type}
        placeholder='00:00-00:00'
        value={value}
        changedColor={changedPlaceholderColor}
        className={`${className} ${changed ? "changed" : ""}`}
        onClick={onClickInput}
        onChange={onChangeInput}
        onKeyDown={onKeyDownInput}
        onFocus={onFocusInput}
        onBlur={onBlurInput}/>
    </InputWrapper>
  )
}

const InputWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: 0px 5px;

  width: calc(${props => props.width}px - 10px);
  height: 30px;

  gap: 6px;

  border: 1px solid ${props => props.theme.line};
  border-radius: 5px;
  background-color: ${props => props.theme.subBackground};
`;

const TimeImage = styled.img`
  width: 18px;
  height: 18px;
`;

const Input = styled.input`
	font-family: NotoSansKR-Regular;
	font-size: 14px;

  padding: 0 0 0 0;

  width: 100%;
  height: calc(100% - 2px);

	outline: none;
  border: 0px solid transparent;

	color: ${props => props.theme.text};
  background-color: transparent;

	::placeholder {
    font-family: NotoSansKR-Regular;
    font-size: 14px;

		color: ${props => props.changedColor ? props.theme.pointRed : props.theme.line};
	}
	
  transition: all 0.3s ease-in-out;
`;